import { render, staticRenderFns } from "./production-order-orders-table.vue?vue&type=template&id=47871875"
import script from "./production-order-orders-table.vue?vue&type=script&lang=js"
export * from "./production-order-orders-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports